export default {
    // https://noodzly.com/app/home
    app: {
        home: {
            subscribed: "Subscribed",
            following: "Following",
            discover: "Discover",
        },
    },
    user: {
        setting: {
            main: {
                //https://noodzly.com/user/setting/main
                title: "Settings",
                delete_account: "Delete Account",
                account_deleted: "Account deleted successfully",
                logout: "Logout",
            },
            info: {
                profile_updated: "Profile updated successfully",
            },
            language: {
                //https://noodzly.com/user/setting/language
                title: "Language",
                button: "Done",
            },
            password: {
                //https://noodzly.com/user/setting/password
                title: "Password",
                old_password: "Old password",
                new_password: "New password",
                confirm_password: "Confirm password",
                update: "Update",
            },
            email: {
                //https://noodzly.com/user/setting/email
                title: "Email",
                email: "Email",
                example: "example@example.com",
                update: "Update",
            },
            //https://noodzly.com/user/setting/notification
            notification: {
                title: "Notifications",
                app: "App",
                follow: "Follow",
                new_subscriber: "New Subscriber",
                messages: "Messages",
                email: "Email",
                fund_sent: "Fund Sent",
                tips_received: "Tips Received",
                save: "Save",
            },
            //https://noodzly.com/user/setting/main
            blacklist: {
                title: "Blocked users",
                empty: "No blocked users found",
            },
            //https://noodzly.com/user/setting/block-regions
            block_regions: {
                title: "Block Regions",
            },
            //https://noodzly.com/user/setting/sessions
            sessions: {
                title: "Sessions",
                something_went_wrong: "Something went wrong?",
                change_your_password: "Change your password",
                device: "Device",
                browser: "Browser",
                date: "Date",
            },
            //https://noodzly.com/user/setting/contact
            contact: {
                title: "Contact Us",
                placeholder: "What's Up?",
                send: "Send",
                sent: "Sent",
                type_label: "What brings you here?",
            },
            //https://noodzly.com/user/setting/creator
            creator: {
                title: "Noodzler",
                verify: {
                    title: "Verify Account",
                },
                agreement: {
                    title: "Agreement Contract",
                    sub_title:
                        "STANDARD AGREEMENT BETWEEN NOODZLY AND NOODZLER",
                    field: {
                        name: "Name",
                    },
                    btn: {
                        accept: "accept",
                    },
                },
                //https://noodzly.com/user/setting/creator/verify-ondato
                verify_ondato: {
                    title: "Verify Your Account",
                    verify_account: "Verified Accounts",
                    action_link: "start verifying",
                    add_another_model: "Add Another Account",
                    model_has_verified: "{name} has been verified on",
                    model_not_verified: "Noodzler {name} is not verified",
                    status_created: " ",
                    status_processed: "processed",
                    status_resolved: "resolved",
                    status_rejected: "rejected",
                    reverify_button: "Re-verify",
                    model_verification_expired: '{name}’s document has expired. Please re-verify to continue',
                    remove_verification: 'Remove',
                },
                withdraw_options: {
                    title: "Withdraw Options",
                    withdraw: {
                        title: "Withdraw",
                        bank_transfer: {
                            title: "EUR Bank Transfer (SEPA)",
                            swift_code: "SWIFT Code",
                            placeholder_swift_code: "Insert SWIFT Code",
                            iban_number: "IBAN Number",
                            placeholder_iban_number: "Insert IBAN Number",
                            bank_name: "Bank Name",
                            placeholder_bank_name: "Type Bank Name",
                            bank_country: "Bank Country",
                            placeholder_bank_country: "Country",
                            convert_currency: "We will convert USD to EUR on the day of payment by {ecb_rate_link}",
                            note_1: "Time to receive payment: Sepa & Swift payments are now processed DAILY (Monday - Friday). Funds requested prior to 23:59 EST will be processed the following business day. Please allow an additional 5 - 7 business days for the funds to settle in your account.",
                            note_2: "NOTE: Your bank (or intermediary bank) may charge you fees in addition to the fees. Fees charged by your bank (or intermediary bank) are not under our control. Please consult with your bank prior to requesting a payment if you are unsure.",
                            beneficiary_name: 'Beneficiary Name',
                            placeholder_beneficiary_name: 'Insert Beneficiary Name',
                            beneficiary_street: 'Beneficiary Street',
                            placeholder_beneficiary_street: 'Insert Beneficiary Street',
                            beneficiary_city: 'Beneficiary City',
                            placeholder_beneficiary_city: 'Insert Beneficiary City',
                            beneficiary_country: 'Beneficiary Country',
                            placeholder_beneficiary_country: 'Insert Beneficiary Country',
                            beneficiary_state: 'Beneficiary State',
                            placeholder_beneficiary_state: 'Insert Beneficiary State',
                            beneficiary_zip: 'Beneficiary Zip',
                            placeholder_beneficiary_zip: 'Insert Beneficiary Zip',
                        },
                        bitsafe: {
                            title: "Yoursafe",
                            full_name: "Full Beneficiary Name",
                            iban: "YourSafe IBAN",
                            country: "Country",
                        },
                        wire_transfer: {
                            title: "International Wire Transfer",
                            swift_code: "SWIFT Code",
                            placeholder_swift_code: "Insert SWIFT Code",
                            iban_number: "IBAN Number",
                            placeholder_iban_number: "Insert IBAN Number",
                            bank_name: "Bank Name",
                            placeholder_bank_name: "Type Bank Name",
                            bank_country: "Bank Country",
                            placeholder_bank_country: "Country",
                            convert_currency: "We will convert USD to EUR on the day of payment by {ecb_rate_link}",
                            note_1: "Time to receive payment: Sepa & Swift payments are now processed DAILY (Monday - Friday). Funds requested prior to 23:59 EST will be processed the following business day. Please allow an additional 5 - 7 business days for the funds to settle in your account.",
                            note_2: "NOTE: Your bank (or intermediary bank) may charge you fees in addition to the fees. Fees charged by your bank (or intermediary bank) are not under our control. Please consult with your bank prior to requesting a payment if you are unsure.",
                            beneficiary_name: 'Beneficiary Name',
                            placeholder_beneficiary_name: 'Insert Beneficiary Name',
                            beneficiary_street: 'Beneficiary Street',
                            placeholder_beneficiary_street: 'Insert Beneficiary Street',
                            beneficiary_city: 'Beneficiary City',
                            placeholder_beneficiary_city: 'Insert Beneficiary City',
                            beneficiary_country: 'Beneficiary Country',
                            placeholder_beneficiary_country: 'Insert Beneficiary Country',
                            beneficiary_state: 'Beneficiary State',
                            placeholder_beneficiary_state: 'Insert Beneficiary State',
                            beneficiary_zip: 'Beneficiary Zip',
                            placeholder_beneficiary_zip: 'Insert Beneficiary Zip',
                        },
                        crypto_wallet: {
                            title: "Crypto",
                            wallet_address: "Crypto Wallet Address",
                            placeholder_wallet_address: "Insert Crypto Wallet Address",
                            crypto_currency: "Crypto",
                            placeholder_crypto_currency: "Select Crypto",
                            country: "Country",
                            placeholder_country: "Select Country",
                        },
                    },
                },
                //https://noodzly.com/user/setting/creator/streams
                streams: {
                    title: "Private Streams",
                    tabs: {
                        now: "Now",
                        later: "Later",
                    },
                    fields: {
                        price: {
                            title: "Price",
                        },
                        ticketsSold: {
                            title: "Tickets Sold",
                        },
                        viewersLimit: {
                            title: "Viewers Limit",
                        },
                        dateTime: {
                            title: "Starts at",
                        },
                        isFreeForSubscribers: {
                            title: "Free for Subscribers",
                        },
                        rating: {
                            title: "Your streams scoring",
                        },
                        isFreeForFollowers: {
                            title: "Free for Followers",
                        },
                        setGoal: {
                            title: "Set Goal",
                        },
                        appearInDiscovery: {
                            title: "Appear in the discovery",
                        }
                    },
                    actions: {
                        schedule: "Schedule",
                        save: "Save",
                        goLive: "Go Live",
                    },
                    rules: {
                        title: "By using live shows you agree to our ",
                        name: "stream rules",
                    },
                },
                stream: {
                    title: "Private Stream",
                    streamIsNotLive: "Stream is not live yet",
                    messages: {
                        system: {
                            joined: "joined",
                        },
                    },
                    liveReport: {
                        title: "Live Report",
                        totalTips: "Total Tips received",
                        totalTickets: "Total Tickets sold",
                        overall: "Overall",
                        totalTicketsInfo: "Revenue generated from ticket sales for your Stream will be credited to your wallet within 24 hours after the Stream concludes",
                    },
                    liveEnded: {
                        title: "Live Ended",
                        rate: {
                            options: {
                                bad: "Bad",
                                ok: "Ok",
                                good: "Good",
                                loveIt: "Love It",
                            },
                        },
                    },
                    streamingNow: "Streaming Now",
                    streamStartedOn: "Started {time} ago",
                },
                //https://noodzly.com/user/setting/creator/subscription
                subscriptions: {
                    title: "Subscriptions",
                    message_title:"(Direct Message)",
                    subscription_price: "Subscription price",
                    per_month: "/Month",
                    welcome_message: "Welcome message",
                    welcome_message_rule:
                        "welcome message will be sent automatically to new subscribers",
                    welcome_audio_message_rule:
                        "* welcome audio message will be sent automatically to new subscribers",
                    audio_note:'Press and hold Mic to record the audio',
                    save: "Save",
                    subscribers: "Subscribers",
                    saved: "Done!",
                    text_message:"Message",
                    video_message:"Audio",
                    start_date:'Start date',
                    end_date:'End date',
                    renewal_date:'Renewal date',
                    total_earning:'Total Earnings',
                    total_spent:'Total Spent',
                    default_active_label:'Active',
                    subscription_default_message: 'Default Message',
                    save_price: "Save Price",
                    save_default_message: "Save Default Message",
                    save_bundles_benefits: "Save Bundles & Benefits",
                    gifted_subscription: "Gifted by {name} ({months})",
                    gifted_by: "Gifted by you ({months})",
                    terminated: "Subscription terminated successfully.",
                    free: "Free"
                },
                //https://noodzly.com/user/setting/creator/tips
                tip_menu: {
                    title: "Tip Menu    ",
                    sub_title_1:
                        "Add items or services for sale.",
                    sub_title_2:
                        "Buyers can buy them directly from your profile.",
                    enter_name: "Add Item Name",
                    save: "Save",
                    saved: "Done!",
                    zero_price: "You can leave 0$ and it will be shown to buyer as 'On Request'",
                    on_request: "On request",
                    error: "Please fill in all fields",
                },
                //https://noodzly.com/user/setting/creator/messages
                messages: {
                    title: "Messages",
                    direct_messages_price: "Direct messages price",
                    placeholder: "0-49.99",
                    save: "SAVE",
                    saved: "Done!",
                    price_suffix: "/Month",
                    direct_message_info: "User that don’t want to subscribe can message you paying this price",
                    price: "Price is required!",
                },

                referrals: {
                    title: "Referrals",
                    description:
                        "For everyone that signs up to Noodzly using your referral code you will receive a bonus equal to 3% of their net earnings for a 12 month period. This bonus is paid to you at the same time as they withdraw their earnings",
                    code: "Code",
                    links: "Links",
                    my_referrals: "My referrals",
                    name: "Name",
                    status: "Status",
                    date: "Date",
                    no_referrals: "No referrals found",
                },

                promotion: {
                    title: "Promotion",
                    description:
                        "Promotion enable you to boost your content in the “Discover” section and reach more people that can turn into new subscribers. Before starting your promotion, you must have at least one content in your story.",
                    notags: "Please select at least one tag",
                    countries: "Countries",
                },

                holiday_mood: {
                    title: "Holiday Mode",
                    description_title: "Anticipating a break from Noodzly?",
                    description_details: "Activate Holiday Mode to pause your subscribers’ subscriptions, ensuring they’re not charged during your absence. This mode automatically deactivates when you post new content.",
                    description_bottom: "If you’re inactive for 72 hours, Holiday Mode will be enabled automatically.",
                    active_label: "Activate",
                },
                dream_goal: {
                    title: "Dream",
                    error: "Please fill in all fields",
                    description_details: "Is there something big you'd like to have or achieve? Set a goal and let people help you with their contributions. When enabled, your Dream is visible in your profile to everyone.",
                    save: "Activate",
                    stop: "Stop",
                    placeholder: {
                        name: "Add Dream Name",
                        price: "Price",
                    },
                    saved: "Done!",
                },
                moderator: {
                    title: "Moderator",
                    description_title: "Want to Become a Moderator 👮‍♀️?",
                    description_title_detail: "Help us keep Noodzly safe and fun for everyone.",
                    description_details: "Spot something wrong or that feels unsafe? Report it. If we take it down, <strong>you’ll earn $0.10</strong> in credits - straight to your wallet.",
                    description_bottom: "Keep things clean, get rewarded 💰",
                    apply: "Apply",
                    pending: "Pending",
                    saved: "Done!",
                    youre_moderator: "You’re a Moderator 👮‍♀️",
                    no_reports: "No reports found.",
                    total_earned : "Total Earned",
                    reward: "Reward",
                    rejected: "Rejected",
                },
                mystery_box: {
                    title: "Mystery Box",
                    price: "Price",
                    total_earning: "Total Earning",
                    status: "Status",
                    heading: "Mystery Box Information",
                    total_available: "Total boxes available",
                    description: "What's inside this mystery box? Tease your fans..",
                    prize_table: "Prize Table",
                    add_prize: "Add Prize",
                    add_message: "Add up tp 10 items",
                    allow_multiple: "Allow Multi-Open",
                    allow_multiple_desc: "Users can buy this multiple times",
                    box_status: "Box Status",
                    box_status_desc: "Mystery box status is:",
                    save: "Active Mystery Box",
                    box_price: "Price of the Box",
                    remaining_boxes: "Remaining Boxes",
                    possible_rewards: "Possible Rewards",
                    open_box: "Open Box for",
                    request_prize: "Request Your Prize",
                    turn_of_box: "Turn Off Mystery Box",
                    prize_sent: "Prize Sent",
                    prize_received: "Prize Received?",
                    prize_message: "{user} won {reward}",
                    won_nothing: "You won nothing this time! Better luck for next time.",
                    you_won: "You Won",
                    congratulaion_message: "Congrats! You've won a {result} with the streamer, {name}",
                    prize_requested: "Prize Requested",
                }
            },
            ideas: "Ideas",
        },
        payment: {
            paypal: {
                payment_processing: "Payment processing...",
                payment_failed: "Payment failed",
                payment_success: "Payment success",
                payment_cancelled: "Payment cancelled",
            },
        },
        onboard: {
            title: "One Last Step!",
            gender: "How do you identify?",
            interested_gender: "I'm interested in",
            age: "What's your age?",
            save: "Let's go",
        },
    },
    profile: {
        //https://noodzly.com/profile
        main: {
            creator: "NOODZLER",
            info: "INFO",
            followers: "Followers",
            following: "Following",
            get_app: "GET THE APP",
            achievements: "ACHIEVEMENTS",
            top_tippers: "YOUR TOP TIPPERS",
            no_tippers: "No tippers at the moment.",
            no_achievements: "No achievements at the moment.",
        },
        //https://noodzly.com/profile/info
        info: {
            title: "Info",
            type_your_bio: "Your Bio",
            amazon_url: "Amazon URL",
            instagram_url: "Instagram URL",
            twitter_url: "X URL",
            my_age: "My Age",
            i_am: "My Sex",
            male: "Male",
            female: "Female",
            transgender: "Transgender",
            categories: "Categories",
            show_achievements: "Show Achievements",
            show_achievements_desc: "Show others your achievements badge",
            show_top_tippers: "Show Top Tippers",
            show_top_tippers_desc: "Show others your top tippers",
            my_countries: "My Country",
            countries: "Country",
            online_status: "Online Status",
            online_status_desc: "Show others when you’re online",
        },
        wallet: {
            //https://noodzly.com/profile/wallet
            withdraw: {
                available_balance: "Available balance",
                total_net: "You will receive",
                total_gross: "Total Gross",
                total_net_info:
                    "{netfee}% fees is used to cover referral payments, hosting, support, and all other services for Noodzly",
                bank_transfer: "EUR Bank Transfer (SEPA)",
                bitsafe: "Yoursafe",
                wire_transfer: "International Wire Transfer",
                crypto_wallet: "Crypto",
                noodzly_fee: "Noodzly Fee",
                additional_fee: "Bank Fee",
                additinal_fee_info: "Bank Fee is used to cover payment processing",
                withdraw_btn: 'Withdraw',
            },
        },
        stream: {
            header: "'s Streams",
            title: "Next Private Stream",
            purchaseTicket: "Buy Ticket",
            startWatching: "Start Watching",
            streamingNow: "Streaming Now",
            streamStartedOn: "Started {time} ago",
        },
        streams: {
            rating: {
                title: "Streams Score",
                stats: {
                    streams: "Streams",
                    min: "min",
                    averageDuration: "Avg Duration",
                },
            },
        },
    },
    //https://noodzly.com/search
    search: {
        placeholder: "Search",
    },
    messages: {
        title: "Messages",
        search: "Search",
        turn_off_direct_messages: "Turn off direct messages",
    },
    channels: {
        title: "Broadcasts",
        yourChannel: "Your broadcast",
        description: {
            forEveryone:
                "Broadcast is a way to receive messages from your Noodzlers to be updated on their next thing!",
            forCreators:
                "Broadcast lets you send messages only to your subscribers to keep them posted on your next thing!",
        },
        other_user_broadcast: "{user_name}'s Broadcast",
        pinned_message: "Pinned message",
    },
    email_verify: {
        title: "Verify Email",
        almost_there: "Almost There!",
        before_link: "Hi {user}, we sent a confirmation email to",
        change: "(Change)",
        after_link: "to get started, confirm your email.",
        button: "RESEND EMAIL",
    },
    privacy: {
        title: "Privacy Policy",
        desc_1: "By using Noodzly.com's services you agree to our Cookies use. We use cookies for purposes including analytics, personalisation and ads.",
        desc_2: "This page and certain others on this site place and read third party cookies on your browser, which are used for non-essential purposes. Through these cookies, our partners collect personal data about you for their own purposes.",
    },
    home: {
        desktop_description:
            "Noodzly allows you to share your amateur content in total anonymity while getting paid and all content will be deleted after 24 hours.",
        qr_code_text: "Scan the QR code",
        qr_code_sub_text: "Better on your smartphone",
        hero_content: {
            title: "Real and Raw",
            description: "Redefining the adult space with authentic, real and raw content. Not fake, not staged.",
            cta_1: "Try Noodzly Now",
            cta_2: "Login",
            stats_1: "Active Creators",
            stats_2: "Creator Earnings",
            stats_3: "Happy Users",
        },
        hero_block_img: {
            text_1: "Scan the QR code",
            text_2: "and try it from your phone.",
        },
        about_us: {
            title: "What's",
            title_highlight: "Noodzly?",
            description: "Noodzly is the home of amateurs. A real-time space where you can share authentic moments with photos, videos or live streams.",
            cta: "Let's Get Noodz 👀",
            features: {
                photo_video: {
                    alt: "photo video",
                    title: "Photo & Video",
                    subtitle: "Share your moments"
                },
                live_streams: {
                    alt: "Live Streams",
                    title: "Live Streams",
                    subtitle: "Go live anytime"
                },
                income_streams: {
                    alt: "Multiple Income Streams",
                    title: "Multiple Income Streams",
                    subtitle: "Subscriptions, tips & more"
                },
                auto_delete: {
                    alt: "24h auto delete",
                    title: "24h Auto-Delete",
                    subtitle: "Content vanishes automatically"
                },
            },
        },
        creator_benefits: {
            title_part1: "Benefits for",
            title_part2: "Creators",
            subtitle: "Snap it. Post it. Earn from it.",
            better_title: "And it gets better:",
            cta_button: "Join the Fun 🎉",
            subscriptions: {
                alt: "Subscriptions",
                title: "Subscriptions"
            },
            photo_video: {
                alt: "photo & video",
                title: "Photo & video"
            },
            pay_per_view: {
                alt: "Pay Per View Content",
                title: "Pay-per-view content"
            },
            private_streams: {
                alt: "Private Streams",
                title: "Private streams"
            },
            tips: {
                alt: "Tips",
                title: "Tips"
            },
            private_requests: {
                alt: "Private Requests",
                title: "Private requests"
            },
            mystery_box: {
                alt: "Mystery Box",
                title: "Mystery Box"
            },
            referral_program: {
                alt: "Referral Program",
                title: "Referral program"
            },
            and_more: {
                alt: "And Much More Icon",
                title: "And much more!"
            },
            better_features: {
                live_solo: {
                    alt: "Subscriptions",
                    text: "Go live solo — or with another creator"
                },
                holiday_mode: {
                    alt: "photo & video",
                    text: "Pause everything anytime with \"Holiday Mode\" on your break"
                },
                privacy_controls: {
                    alt: "Pay Per View Content",
                    text: "Full privacy controls: choose who can see your profile"
                },
                disappearing_content: {
                    alt: "Private Streams",
                    text: "Share content that disappears after 24h"
                },
                fast_payouts: {
                    alt: "Tips",
                    text: "Fast and easy payouts"
                }
            },
        },
        fan_benefits: {
            title_part1: "Benefits for",
            title_part2: "Fans",
            subtitle: "Chill. Explore. Support.",
            cta_button: "Start Exploring 🔥",
            discover_content: {
                alt: "Discover Real Unfiltered Content",
                title: "Discover real, unfiltered content"
            },
            real_time: {
                alt: "Real Time People and Moments",
                title: "Real-time people and moments"
            },
            subscribe: {
                alt: "Subscribe To Your Favorite Creators",
                title: "Subscribe to your favorite creators"
            },
            tips_requests: {
                alt: "Send Tips Or Request Something Personal",
                title: "Send tips or request something personal"
            },
            easy_signup: {
                alt: "sign up With Just an Email and Password",
                title: "Sign up with just an email and password"
            },
            wallet: {
                alt: "In App Wallet To Support Your Faves",
                title: "In-app wallet to support your faves"
            }
        },
        safety: {
            title: "Safety first —",
            title_highlight: "Always",
            subtitle: "Your safety is our priority. We've built Noodzly to be a safe, trusted space.",
            trusted_space: {
                heading: "We've built Noodzly to be a safe, trusted space.",
                creators_verified: "All creators are verified",
                profile_control: "Full control over your profile visibility",
                auto_delete: "All content auto-deletes in 24h",
                secure_payments: "Payments stay inside the app with our secure wallet system",
                image_alt: "Built Noodzly To be a Safe Trusted Space"
            },
            protection: {
                heading: "Protection that matters",
                description: "We take your privacy seriously. Your data and content are fully protected and the content deleted automatically. We comply with all industry standards.",
                image_alt: "Protection That Matters"
            },
            support: {
                heading_one: "Need help?",
                heading_two: "Real humans, 24/7",
                description: "Our support team is always here to help — fast, friendly, and ready when you need us.",
                image_alt: "Need help? Real humans, 24/7"
            }
        },
        cta: {
            title: "Ready to become a Noodzler?",
            subtitle: "Whether you're here to post or just peek, there's a place for you.",
            description: "Try it now from your phone. Scan the QR code and have fun 🧡",
            qr_alt: "scan QR code"
        },
        footer_block: {
            title: "Explore, have fun, and connect",
        },
        choose_noodzly: {
            title_part1: "Why creators and fans choose",
            title_part2: "Noodzly?",
            cta_button: "Join Noodzly Now 🔥"
        }
    },
    //https://noodzly.com/user/5/tips
    user_tips: {
        title: "{name}’s Tip Menu",
        subtitle: "Items or services for sale by {name}",
        zero_price_text: "You want to request {item_name}?",
        buy_item_text: "You want to buy {tip_name} for {tip_price}$ ?",
    },
    copyright: "&copy;{year} Noodzly. All Rights Reserved.",
    other_user: {
        labels: {
            icons: {
                message: "Message",
                menu: "Menu",
                tip: "Tip",
                live: "Live",
                dream: "Dream",
                mystery: "Mystery",
                box: "Box",
            },
        },
        achievements: {
            title: "ACHIEVEMENTS",
        },
        top_tippers: {
            title: "TOP TIPPERS",
        }
    },
    leaderboards: {
        title: "Leaderboard",
    },
    sign_up: {
        age_confirmation: "I confirm that I am at least 18 years old",
        term_condition: "I confirm that I have read and agree to the",
        content_acknowledge: "I acknowledge and agree that my images and content may be used and displayed publicly on Noodzly.",
        provider_agreement: "I confirm that I have read and agree to the",
    }
};
